import styled from 'styled-components';

export const Description = styled.p`
  font-size: 14px;
  color: #333;
  padding: 16px 16px 0;
  margin: 0;
`;

export const Warning = styled.p`
  font-size: 13px;
  color: #a15c00;
  background-color: #fff6e5;
  border: 1px solid #ffd591;
  border-radius: 6px;
  padding: 10px 12px;
  margin: 12px 16px 0;
`;

export const List = styled.div`
  margin: 12px 16px 0;
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 6px;
`;

export const Row = styled.div`
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  label {
    display: grid;
    grid-template-columns: 20px 1fr 120px 140px;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    cursor: pointer;
    font-size: 13px;
  }

  span {
    color: #777;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px;
`;
